import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';
import DeleteTextButton from '../atoms/DeleteTextButton';
// import DeleteMenuEventTextButton from '../atoms/DeleteMenuEventTextButton';
import listMenuChildTypes from '../../constants/MenuChildType';
import ShowHideSwitchButton from '../atoms/ShowHideSwitchButton';
import CoppyButton from '../atoms/CoppyButton';
import enabledStripeBilling from '../../constants/StripeBilling';
import ChangeShashokuOptionButton from '../atoms/ChangeShashokuOptionButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  textDelete: {
    color: '#ccc',
    textAlign: 'center',
    paddingLeft: 12
  },
  menuImage: {
    width: 100,
    objectFit: 'cover'
  },
  noImage: {
    width: 100,
    height: 63,
    backgroundColor: '#D1D1D1',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: '#A5A5A5',
    fontSize: 10
  },
  disabledMenu: {
    opacity: 0.5
  },
  displayTypeCell: {
    display: 'flex',
    alignItems: 'center'
  },
  changeShashokuOptionButton: {
    padding: '0px 15px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      menuId: PropTypes.number,
      menuChildType: PropTypes.number,
      shopName: PropTypes.string,
      menuName: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
      taxType: PropTypes.string,
      image: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    menus,
    classes,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    editOpenAction,
    deleteOpenAction,
    showHideOpenAction,
    changeShashokuOptionAction,
    order,
    orderBy,
    roles,
    isFukuoka
  }) => {
    const sortedResult = _.orderBy(menus, orderBy, order);
    const listMenuTypeHideEdit = ['DEFAULT'];
    const listMenuTypeHideEditForShopGroup = ['AKISHIMA', 'EVENT'];
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(gochiMenu => {
            let option = null;
            let titleStatus = null;
            if (gochiMenu.shashokuOption) {
              if (
                gochiMenu.shashokuFlag === 1 &&
                gochiMenu.gochimeshiFlag === 1
              ) {
                option = 'both';
              } else {
                option =
                  gochiMenu.shashokuFlag === 1 ? 'shashoku' : 'gochimeshi';
              }
            }
            const titleStatusArr = [];
            if (gochiMenu.gochimeshiFlag === 1) {
              titleStatusArr.push('ごちめし（さきめし含む）');
            }
            if (gochiMenu.shashokuFlag === 1) {
              titleStatusArr.push('社食ごちめし');
            }
            if (gochiMenu.gochiKidFlag === 1) {
              titleStatusArr.push('こどもごちめし');
            }
            titleStatus = titleStatusArr.join(', ');
            const params = {
              id: gochiMenu.menuId,
              showHide: gochiMenu.showHide,
              gochimeshiFlag: gochiMenu.gochimeshiFlag,
              shashokuFlag: gochiMenu.shashokuFlag,
              gochiKidFlag: gochiMenu.gochiKidFlag,
              menuEventId: gochiMenu.menuEventId,
              menuEvents: gochiMenu.menuEventManuals
            };

            const key = `${gochiMenu.menuId}-${gochiMenu.shopId}-${
              gochiMenu.groupName
            }`;

            return (
              <TableRow key={key} hover>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.image ? (
                    <img
                      src={gochiMenu.image}
                      width={100}
                      height={63}
                      className={classes.menuImage}
                      alt="Menu"
                    />
                  ) : (
                    <div className={classes.noImage}>NO IMAGE</div>
                  )}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.shopId}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.shopName}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.menuId}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {gochiMenu.menuName}
                </TableCell>
                <TableCell
                  className={gochiMenu.showHide ? '' : classes.disabledMenu}
                >
                  {listMenuChildTypes.map(item => {
                    if (parseInt(gochiMenu.menuChildType, 10) === item.id) {
                      let itemName = item.name;
                      if (isFukuoka) {
                        if (item.id === 1) {
                          itemName = '通常（教室別）';
                        } else if (item.id === 4 || item.id === 5) {
                          itemName = 'グループ共通';
                        }
                      }
                      return itemName;
                    }
                    return '';
                  })}
                </TableCell>
                {!isFukuoka && (
                  <TableCell
                    className={gochiMenu.showHide ? '' : classes.disabledMenu}
                  >
                    {gochiMenu.menuLimitTotal === 1
                      ? '一円単位利用'
                      : '一枚単位利用'}
                  </TableCell>
                )}
                {enabledStripeBilling === true && (
                  <TableCell>
                    {gochiMenu.subscription === 1 &&
                      `${gochiMenu.subscriptionIntervalCount}${
                        gochiMenu.subscriptionInterval === 'WEEK'
                          ? '週間'
                          : 'ヶ月'
                      }1回`}
                  </TableCell>
                )}
                <TableCell>{gochiMenu.price}</TableCell>
                <TableCell>{gochiMenu.taxTypeStr}</TableCell>
                <TableCell>
                  <div className={classes.displayTypeCell}>
                    {gochiMenu.displayType !== 'HIDDEN' && (
                      <ShowHideSwitchButton
                        params={params}
                        onClickAction={showHideOpenAction}
                        showHide={gochiMenu.showHide}
                        disabled={
                          gochiMenu.menuEventId &&
                          gochiMenu.showHide === 0 &&
                          (roles.isShop || roles.isGroup)
                        }
                      />
                    )}
                    {!isFukuoka && (
                      <ChangeShashokuOptionButton
                        className={classes.changeShashokuOptionButton}
                        disabled={option === null}
                        titleStatus={titleStatus}
                        params={params}
                        onClickAction={changeShashokuOptionAction}
                      />
                    )}
                  </div>
                </TableCell>
                {!isFukuoka && (
                  <TableCell>
                    <CoppyButton
                      linkToCopy={`https://web.app-gochimeshi.com/?id=${
                        gochiMenu.menuId
                      }`}
                    />
                  </TableCell>
                )}
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                <TableCell>
                  {roles.isSecretariat &&
                    !listMenuTypeHideEdit.includes(gochiMenu.menuType) &&
                    gochiMenu.displayType !== 'HIDDEN' && (
                      <EditTextButton
                        id={gochiMenu.menuId}
                        onClickAction={editOpenAction}
                      />
                    )}
                  {!roles.isSecretariat &&
                    !listMenuTypeHideEditForShopGroup.includes(
                      gochiMenu.menuType
                    ) &&
                    !listMenuTypeHideEdit.includes(gochiMenu.menuType) &&
                    gochiMenu.menuCombo !== 1 &&
                    gochiMenu.subscription !== 1 &&
                    gochiMenu.menuChildType !== 5 &&
                    gochiMenu.displayType !== 'HIDDEN' &&
                    ((gochiMenu.menuChildType !== 2 &&
                      gochiMenu.menuChildType !== 3) ||
                      isFukuoka) && (
                      <EditTextButton
                        id={gochiMenu.menuId}
                        onClickAction={editOpenAction}
                      />
                    )}
                </TableCell>
                <TableCell>
                  {/* {!roles.isShop && !roles.isGroup && (
                    <DeleteTextButton
                      id={gochiMenu.menuId}
                      onClickAction={deleteOpenAction}
                    />
                  )} */}
                  {gochiMenu.menuChildType !== 5 &&
                    (gochiMenu.displayType !== 'HIDDEN' ? (
                      <DeleteTextButton
                        id={gochiMenu.menuId}
                        onClickAction={deleteOpenAction}
                      />
                    ) : (
                      <div className={classes.textDelete}>削除済</div>
                    ))}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          // <TableRow style={{ height: 49 * emptyRows }}>
          //   <TableCell colSpan={7} />
          // </TableRow>
          <></>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
